const CheckIcon = (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
        <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m2.5 8.5 4 4 7-9" />
    </svg>
);

export default CheckIcon;
